/**
 * @Author : zhouqinze
 * @Date : 2019-12-30
 * @Version : 1.0
 * @Content : 荣誉资质
 **/
<template>
    <div>
        <div class="aboutComHead">
            <p>荣誉资质</p>
            <p><span></span><span></span></p>
        </div>
        <div class="honorCon">
            <div class="conBox"><div class="imgBox"><div class="icon"></div></div><p>高新技术企业证书</p></div>
            <div class="conBox"><div class="imgBox"><div class="icon"></div></div><p>广州企业研究开发机构证书</p></div>
            <div class="conBox"><div class="imgBox"><div class="icon"></div></div><p>质量管理体系认证证书</p></div>
            <div class="conBox"><div class="imgBox"><div class="icon"></div></div><p>知识产权管理体系认证证书</p></div>
            <div class="conBox"><div class="imgBox"><div class="icon"></div></div><p>荣获2015中国（小谷围）”互联网+ 运输服务”创客大赛十大优秀在用项 目金奖</p></div>
            <div class="conBox"><div class="imgBox"><div class="icon"></div></div><p>荣获搜狐汽车“2015年度最佳汽车 用品企业”大奖</p></div>
            <div class="conBox"><div class="imgBox"><div class="icon"></div></div><p>荣获“2016年度汽车电子科学技术 优秀创意产品奖”</p></div>
            <div class="conBox"><div class="imgBox"><div class="icon"></div></div><p>荣获2016年“珠江天使杯”科技创新 创业大赛“优秀企业奖”</p></div>
            <div class="conBox"><div class="imgBox"><div class="icon"></div></div><p>荣获“2016首届中国智能终端大奖” 优秀奖</p></div>
            <div class="conBox"><div class="imgBox"><div class="icon"></div></div><p>发明专利证书（8项）</p></div>
            <div class="conBox"><div class="imgBox"><div class="icon"></div></div><p>实用新型专利证书（10项）</p></div>
            <div class="conBox"><div class="imgBox"><div class="icon"></div></div><p>计算机软件著作权（38项）</p></div>
        </div>
    </div>
</template>

<script>
export default {
    
}
</script>

<style lang="scss" scoped>
    .aboutComHead{
        width: 5.875rem;
        font-size: 1.4375rem;
        color: #333;
        margin-bottom: .75rem;
        font-weight: bold;
        margin-bottom: 1.25rem;
        span{
            display: inline-block;
            width: 50%;
            height: .1875rem;
            background: #018CF4;
        }
        span:last-child{
            background: #ddd;
        }
    }
    .honorCon{
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .conBox{
        width: 18.1875rem;
        box-sizing: border-box;
            .imgBox{
                width: 100%;
                height: 16.25rem;
                display: flex;
                justify-content: center;
                align-items: center;
                background: #eee;
                .icon{
                    display: block;
                    width: 100%;
                    height: 100%;
                    background-image: url(http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_zzry.png);
                    background-repeat: no-repeat;
                    background-position: -2.0625rem -3.125rem;
                }
            }
            p{
                font-size: 1rem;
                color: #333;
                margin: 1.25rem 0 2.875rem;
            }
        }
        .conBox:nth-child(2){
            .imgBox{
                .icon{
                    background-position: -24.5625rem -3.125rem;
                }
            }
        }
        .conBox:nth-child(3){
            .imgBox{
                .icon{
                    background-position: -47.0625rem -3.125rem;
                }
            }
        }
        .conBox:nth-child(4){
            .imgBox{
                .icon{
                    background-position: -69.5625rem -3.125rem;
                }
            }
        }
        .conBox:nth-child(5){
            .imgBox{
                .icon{
                    background-position: -92.0625rem -3.125rem;
                }
            }
        }
        .conBox:nth-child(6){
            .imgBox{
                .icon{
                    background-position: -114.5625rem -3.125rem;
                }
            }
        }
        .conBox:nth-child(7){
            .imgBox{
                .icon{
                    background-position: -137.0625rem -3.125rem;
                }
            }
        }
        .conBox:nth-child(8){
            .imgBox{
                .icon{
                    background-position: -159.5625rem -3.125rem;
                }
            }
        }
        .conBox:nth-child(9){
            .imgBox{
                .icon{
                    background-position: -182.0625rem -3.125rem;
                }
            }
        }
        .conBox:nth-child(10){
            .imgBox{
                .icon{
                    background-position: -204.5625rem -3.125rem;
                }
            }
        }
        .conBox:nth-child(11){
            .imgBox{
                .icon{
                    background-position: -227.0625rem -3.125rem;
                }
            }
        }
        .conBox:nth-child(12){
            .imgBox{
                .icon{
                    background-position: -249.5625rem -3.125rem;
                }
            }
        }
    }
</style>